import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-folder",
  "use": "icon-file-folder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-folder\"><defs><style type=\"text/css\"></style></defs><path d=\"M843.5 226.2H473.6l-78.4-70.8H139.3l-76.8 70.8v521.3c0 64 51.9 115.9 115.9 115.9h665c64 0 115.9-51.9 115.9-115.9V342.1c0-64-51.8-115.9-115.8-115.9z\" p-id=\"2569\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-folder.svg
// module id = dLDj
// module chunks = 20